export enum BlockPageToLinkEnum {
  HISTORY = 'history',
  LANDING_PAGE = 'landing-page',
  MY_PAGE = 'my-page',
  FORM = 'form',
  LOTTERY = 'lottery',
  GATE = 'gate',
  COMPLETE = 'complete'
}
